<section class="assets glass-panel">
  <div class="wn-page-header">
    <div class="wn-page-title">
      <p class="eyebrow">{{ 'ASSETS.EYEBROW' | translate }}</p>
      <h1>{{ 'ASSETS.TITLE' | translate }}</h1>
      <p class="lede">{{ 'ASSETS.LEDE' | translate }}</p>
    </div>
    <div class="wn-page-actions">
      @if (view() === 'categories') {
        <button type="button" pButton [outlined]="true" icon="pi pi-plus" class="assets__new" [label]="'ASSETS.NEW_CATEGORY' | translate" (click)="openNewCategory()"></button>
      } @else {
        <a pButton [outlined]="true" icon="pi pi-plus" class="assets__new" routerLink="/assets/new" [label]="'ASSETS.NEW_ASSET' | translate"></a>
      }
    </div>
  </div>

  <div class="assets__tabs" role="tablist">
    <button type="button" role="tab" [attr.aria-selected]="view() === 'assets'" [class.is-active]="view() === 'assets'" (click)="setView('assets')">
      {{ 'ASSETS.TAB_ASSETS' | translate }}
    </button>
    <button type="button" role="tab" [attr.aria-selected]="view() === 'assignments'" [class.is-active]="view() === 'assignments'" (click)="setView('assignments')">
      {{ 'ASSETS.TAB_ASSIGNMENTS' | translate }}
    </button>
    <button type="button" role="tab" [attr.aria-selected]="view() === 'maintenance'" [class.is-active]="view() === 'maintenance'" (click)="setView('maintenance')">
      {{ 'ASSETS.TAB_MAINTENANCE' | translate }}
    </button>
    <button type="button" role="tab" [attr.aria-selected]="view() === 'categories'" [class.is-active]="view() === 'categories'" (click)="setView('categories')">
      {{ 'ASSETS.TAB_CATEGORIES' | translate }}
    </button>
  </div>

  @if (error(); as err) {
    <p class="assets__error" role="alert">{{ err }}</p>
  }

  @if (view() === 'assets') {
    <form class="assets__filters" [formGroup]="filterForm" (ngSubmit)="applyFilter()" wnAutoFilter (wnAutoFilterApply)="applyFilter()">
      <div class="assets__toolbar">
        <label class="assets__search">
          <span class="assets__filter-label">{{ 'COMMON.SEARCH' | translate }}</span>
          <input class="assets__search-input" formControlName="search" type="search" [placeholder]="'ASSETS.SEARCH_PLACEHOLDER' | translate" />
        </label>
        <label>
          <span class="assets__filter-label">{{ 'ASSETS.CATEGORY' | translate }}</span>
          <select formControlName="categoryId">
            <option value="">{{ 'ASSETS.ALL_CATEGORIES' | translate }}</option>
            @for (category of categories(); track category.id) {
              <option [value]="category.id">{{ title(category) }}</option>
            }
          </select>
        </label>
        <label>
          <span class="assets__filter-label">{{ 'COMMON.STATUS' | translate }}</span>
          <select formControlName="status">
            <option value="">{{ 'ASSETS.ALL_STATUSES' | translate }}</option>
            @for (status of assetStatuses; track status) {
              <option [value]="status">{{ statusLabel(status) | translate }}</option>
            }
          </select>
        </label>
        <button pButton type="button" class="assets__reset" [outlined]="true" [disabled]="loading()" [label]="'COMMON.RESET_FILTERS' | translate" (click)="resetFilters()"></button>
      </div>
    </form>

    @if (loading()) {
      <p class="assets__status" role="status">{{ 'ASSETS.LOADING' | translate }}</p>
    } @else if (!rows().length && !error()) {
      <wn-empty-state icon="pi pi-box" [title]="'ASSETS.EMPTY' | translate">
        <button type="button" pButton [outlined]="true" [disabled]="loading()" (click)="resetFilters()">{{ 'COMMON.RESET_FILTERS' | translate }}</button>
        <a pButton icon="pi pi-plus" routerLink="/assets/new" [label]="'ASSETS.NEW_ASSET' | translate"></a>
      </wn-empty-state>
    } @else if (rows().length) {
      <div class="assets__table-wrap">
        <table class="assets__table">
          <thead>
            <tr>
              <th scope="col">{{ 'ASSETS.CODE' | translate }}</th>
              <th scope="col">{{ 'ASSETS.ASSET' | translate }}</th>
              <th scope="col">{{ 'ASSETS.CATEGORY' | translate }}</th>
              <th scope="col">{{ 'COMMON.STATUS' | translate }}</th>
              <th scope="col">{{ 'ASSETS.ASSIGNED_TO' | translate }}</th>
              <th scope="col">{{ 'COMMON.ACTIONS_LABEL' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.id) {
              <tr>
                <td><span class="assets__code">{{ row.assetCode }}</span></td>
                <td class="assets__clamp" [attr.title]="title(row)"><a class="assets__row-link" [routerLink]="['/assets', row.id]">{{ title(row) }}</a></td>
                <td class="assets__clamp" [attr.title]="categoryTitle(row)">{{ categoryTitle(row) }}</td>
                <td><wn-status-chip [label]="statusLabel(row.status) | translate" /></td>
                <td class="assets__clamp" [attr.title]="row.currentAssignedUserFullName || null">{{ row.currentAssignedUserFullName || '-' }}</td>
                <td class="assets__actions">
                  <app-table-actions [label]="'COMMON.ACTIONS_LABEL' | translate">
                    <a [routerLink]="['/assets', row.id]" role="menuitem">
                      <i class="pi pi-eye" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.DETAILS' | translate }}</span>
                    </a>
                    <a [routerLink]="['/assets', row.id, 'edit']" role="menuitem">
                      <i class="pi pi-pencil" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.EDIT' | translate }}</span>
                    </a>
                    <button type="button" role="menuitem" [disabled]="!canSendToMaintenance(row)" (click)="runAction(row, 'maintenance')">
                      <i class="pi pi-wrench" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.SEND_MAINTENANCE' | translate }}</span>
                    </button>
                    <button type="button" role="menuitem" [disabled]="!canMarkDamaged(row)" (click)="openLossDialog(row, 'damaged')">
                      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.MARK_DAMAGED' | translate }}</span>
                    </button>
                    <button type="button" role="menuitem" [disabled]="!canMarkLost(row)" (click)="openLossDialog(row, 'lost')">
                      <i class="pi pi-ban" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.MARK_LOST' | translate }}</span>
                    </button>
                    <button type="button" class="is-danger" role="menuitem" [disabled]="!canRetire(row)" (click)="runAction(row, 'retire')">
                      <i class="pi pi-times-circle" aria-hidden="true"></i>
                      <span>{{ 'ASSETS.RETIRE' | translate }}</span>
                    </button>
                  </app-table-actions>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <wn-list-paginator
      [skip]="skip()"
      [pageSize]="pageSize()"
      [total]="totalCount()"
      [loading]="loading()"
      (pageChange)="changePage($event)"
      (pageSizeChange)="changePageSize($event)"
    ></wn-list-paginator>
  }

  @if (view() === 'assignments') {
    <div class="wn-segments assets__segments" role="group" [attr.aria-label]="'ASSETS.TAB_ASSIGNMENTS' | translate">
      <button type="button" [class.is-active]="!returnRequestedOnly()" [attr.aria-pressed]="!returnRequestedOnly()" (click)="setReturnRequestedOnly(false)">
        {{ 'ASSETS.ALL_ASSIGNMENTS' | translate }}
      </button>
      <button type="button" data-filter="return-requested" [class.is-active]="returnRequestedOnly()" [attr.aria-pressed]="returnRequestedOnly()" (click)="setReturnRequestedOnly(true)">
        {{ 'ASSETS.RETURN_REQUESTED' | translate }}
      </button>
    </div>
    @if (loading()) {
      <p class="assets__status" role="status">{{ 'ASSETS.LOADING' | translate }}</p>
    } @else if (!assignments().length) {
      <wn-empty-state icon="pi pi-users" [title]="(returnRequestedOnly() ? 'ASSETS.EMPTY_RETURN_REQUESTS' : 'ASSETS.EMPTY_ASSIGNMENTS') | translate" />
    } @else {
      <div class="assets__table-wrap">
        <table class="assets__table assets__table--compact">
          <thead><tr><th scope="col">{{ 'ASSETS.ASSET' | translate }}</th><th scope="col">{{ 'ASSETS.EMPLOYEE' | translate }}</th><th scope="col">{{ 'ASSETS.ASSIGNED_AT' | translate }}</th><th scope="col">{{ 'COMMON.STATUS' | translate }}</th><th scope="col">{{ 'ASSETS.RETURN_REQUESTED' | translate }}</th></tr></thead>
          <tbody>
            @for (row of assignments(); track row.id) {
              <tr>
                <td class="assets__clamp" [attr.title]="title(row)"><a [routerLink]="['/assets', row.assetId]">{{ title(row) }}</a></td>
                <td class="assets__clamp" [attr.title]="row.assignedToUserFullName || null">{{ row.assignedToUserFullName || '-' }}</td>
                <td>{{ row.assignedAt | date: 'mediumDate':'UTC' }}</td>
                <td><wn-status-chip [label]="assignmentStatusLabel(row.assignmentStatus) | translate" /></td>
                <td>
                  @if (isReturnPending(row)) {
                    <span class="assets__return-request">
                      <wn-status-chip tone="warning" [label]="(row.returnRequestedAt | date: 'mediumDate':'UTC') ?? ''" />
                      <a class="assets__return-link" [routerLink]="['/assets', row.assetId]">{{ 'ASSETS.PROCESS_RETURN' | translate }}</a>
                    </span>
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }

  @if (view() === 'maintenance') {
    @if (loading()) {
      <p class="assets__status" role="status">{{ 'ASSETS.LOADING' | translate }}</p>
    } @else if (!maintenances().length) {
      <wn-empty-state icon="pi pi-wrench" [title]="'ASSETS.EMPTY_MAINTENANCE' | translate" />
    } @else {
      <div class="assets__table-wrap">
        <table class="assets__table assets__table--compact">
          <thead><tr><th scope="col">{{ 'ASSETS.ASSET' | translate }}</th><th scope="col">{{ 'ASSETS.PROVIDER' | translate }}</th><th scope="col">{{ 'ASSETS.DATE' | translate }}</th><th scope="col">{{ 'ASSETS.COST' | translate }}</th><th scope="col">{{ 'COMMON.STATUS' | translate }}</th></tr></thead>
          <tbody>
            @for (row of maintenances(); track row.id) {
              <tr><td class="assets__clamp" [attr.title]="title(row)">{{ title(row) }}</td><td class="assets__clamp" [attr.title]="row.providerTitle || null">{{ row.providerTitle || '-' }}</td><td>{{ row.maintenanceDate | date: 'mediumDate':'UTC' }}</td><td>{{ row.cost ?? '-' }}</td><td><wn-status-chip [label]="maintenanceStatusLabel(row.status) | translate" /></td></tr>
            }
          </tbody>
        </table>
      </div>
    }
  }

  @if (view() === 'categories') {
    <section class="assets__category-list">
      <div class="assets__category-list-head">
        <div>
          <h2>{{ 'ASSETS.CATEGORIES_TITLE' | translate }}</h2>
          <p>{{ 'ASSETS.CATEGORIES_LEDE' | translate }}</p>
        </div>
      </div>
      @if (!categories().length) {
        <wn-empty-state icon="pi pi-tags" [title]="'ASSETS.EMPTY_CATEGORIES' | translate">
          <button type="button" pButton icon="pi pi-plus" [label]="'ASSETS.NEW_CATEGORY' | translate" (click)="openNewCategory()"></button>
        </wn-empty-state>
      } @else {
        <div class="assets__table-wrap assets__table-wrap--categories">
          <table class="assets__table assets__table--categories">
            <thead>
              <tr>
                <th scope="col">{{ 'ASSETS.CATEGORY' | translate }}</th>
                <th scope="col">{{ 'ASSETS.DESCRIPTION' | translate }}</th>
                <th scope="col">{{ 'COMMON.STATUS' | translate }}</th>
                <th scope="col">{{ 'COMMON.ACTIONS_LABEL' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (category of categories(); track category.id) {
                <tr>
                  <td>
                    <span class="assets__row-title">{{ title(category) }}</span>
                    <small>{{ isArabic() ? category.titleEn : category.titleAr }}</small>
                  </td>
                  <td class="assets__clamp assets__clamp--wide" [attr.title]="category.description || null">{{ category.description || '-' }}</td>
                  <td>
                    <wn-status-chip [tone]="category.isActive ? 'success' : 'neutral'" [label]="(category.isActive ? 'COMMON.ACTIVE' : 'COMMON.INACTIVE') | translate" />
                  </td>
                  <td class="assets__actions">
                    <app-table-actions [label]="'COMMON.ACTIONS_LABEL' | translate">
                      <button type="button" role="menuitem" (click)="editCategory(category)">
                        <i class="pi pi-pencil" aria-hidden="true"></i>
                        <span>{{ 'ASSETS.EDIT' | translate }}</span>
                      </button>
                      <button type="button" role="menuitem" (click)="toggleCategory(category)">
                        <i [class]="category.isActive ? 'pi pi-ban' : 'pi pi-check'" aria-hidden="true"></i>
                        <span>{{ (category.isActive ? 'ASSETS.DEACTIVATE' : 'ASSETS.ACTIVATE') | translate }}</span>
                      </button>
                    </app-table-actions>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }

  <benefits-dialog
    [open]="categoryDialogOpen()"
    [heading]="(editingCategoryId() ? 'ASSETS.EDIT_CATEGORY' : 'ASSETS.NEW_CATEGORY') | translate"
    [eyebrow]="'ASSETS.TAB_CATEGORIES' | translate"
    [closeDisabled]="savingCategory()"
    (closed)="closeCategoryDialog()"
  >
    <form id="asset-category-form" class="assets__category-form" [formGroup]="categoryForm" (ngSubmit)="saveCategory()" novalidate>
      <p class="assets__category-lede">{{ 'ASSETS.CATEGORY_FORM_LEDE' | translate }}</p>
      @if (categoryError(); as message) {
        <p class="wn-banner wn-banner--danger" role="alert">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ message }}</span>
        </p>
      }
      <fieldset class="assets__category-fields" [disabled]="savingCategory()">
        @for (lang of langOrder; track lang) {
          @if (lang === 'en') {
            <label class="field">
              <span class="field__label">{{ 'ASSETS.TITLE_EN' | translate }}</span>
              <input class="field__input" type="text" formControlName="titleEn" />
              @if (titleErrorKey(categoryForm.controls.titleEn); as errorKey) {
                <span class="field__error">{{ errorKey | translate }}</span>
              }
            </label>
          } @else {
            <label class="field">
              <span class="field__label">{{ 'ASSETS.TITLE_AR' | translate }}</span>
              <input class="field__input" type="text" formControlName="titleAr" dir="rtl" />
              @if (titleErrorKey(categoryForm.controls.titleAr); as errorKey) {
                <span class="field__error">{{ errorKey | translate }}</span>
              }
            </label>
          }
        }
        <label class="field">
          <span class="field__label">{{ 'ASSETS.DESCRIPTION' | translate }}</span>
          <input class="field__input" type="text" formControlName="description" />
        </label>
        <label class="field field--checkbox">
          <input type="checkbox" formControlName="isActive" />
          <span class="field__label">{{ 'COMMON.ACTIVE' | translate }}</span>
        </label>
      </fieldset>
    </form>

    <ng-container benefitsDialogFooter>
      <button type="button" pButton [outlined]="true" [label]="'COMMON.CANCEL' | translate" [disabled]="savingCategory()" (click)="closeCategoryDialog()"></button>
      <button type="submit" form="asset-category-form" pButton icon="pi pi-check" [label]="'COMMON.SAVE' | translate" [loading]="savingCategory()"></button>
    </ng-container>
  </benefits-dialog>

  @if (lossTarget(); as target) {
    <app-asset-loss-dialog
      [mode]="target.mode"
      [asset]="{ purchaseCost: target.asset.purchaseCost, assignedUserId: target.asset.currentAssignedUserId, assignedUserName: target.asset.currentAssignedUserFullName }"
      (confirmed)="confirmLoss($event)"
      (closed)="closeLossDialog()"
    />
  }
</section>
